import React from 'react';
import { CustomFieldEntitySubType, CustomFieldUtil } from '../../../../../../types/custom_field';
import InnerFilterContent, { FilterInnerContentProps } from '../../../common/DropdownContent/DynamicFilterInnerContent';

export function CustomFieldEntitySubTypeFilterInnerContent({
  filter,
  filterProps,
  setFilterProps,
}: FilterInnerContentProps<CustomFieldEntitySubType>) {
  return (
    <InnerFilterContent
      filterProps={{ filterProps, setFilterProps }}
      filter={filter}
      items={[...(filterProps.customFieldEntitySubType || [])]}
      text={item => CustomFieldUtil.customFieldEntitySubtypeToString(item as CustomFieldEntitySubType)}
      onRemove={i => {
        filterProps.customFieldEntitySubType?.delete(i);
        if (!filterProps.customFieldEntitySubType?.size) filterProps.customFieldEntitySubType = undefined;
        setFilterProps({ ...filterProps });
      }}
    />
  );
}
